import {
    ChangeDetectionStrategy,
    Component,
    inject,
    Input,
    OnInit,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { IContactSelected, IVoiceCommand } from '@dxp/core/models';
import { VoiceService } from '@dxp/core/services';
import { VoiceApiService } from '@dxp/core/api';
import { delay, of } from 'rxjs';

@Component({
    selector: 'voice-contacts-voice-ivr',
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [CommonModule],
    templateUrl: './voice-ivr.component.html',
    styleUrl: './voice-ivr.component.scss',
})
export class VoiceContactVoiceIvrComponent implements OnInit {
    private voiceApiService = inject(VoiceApiService);
    private voiceService = inject(VoiceService);

    @Input({ required: true }) contactSelected!: IContactSelected;
    @Input({ required: true }) conversationId!: string;

    now: Date | undefined;

    ngOnInit() {
        const params: IVoiceCommand = {
            conversationId: this.conversationId,
            destination: this.contactSelected.identifier ?? '',
            newCallCommand: 'YoYoIVR',
        };
        this.voiceService.hideContacts();
        of(params)
            .pipe(delay(2000))
            .subscribe(delayedParams => {
                this.voiceApiService.callCommand(delayedParams);
            });
        this.now = new Date();
    }
}
